























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Calendar, Dialog, Field, Tag, Tab, Tabs } from "vant";
import productHome from "../modules/productHome.vue";
import dataShare from "../dataShare";
import * as _ from "lodash";
import session from "@/utils/session";
import { YesOrNo, ZoneType } from "@/model/Base";
import moment from "moment";
import baseService from "@/service/baseService";
import huilianyiService from "@/service/huilianyiService";
import hotelService from "@/service/hotelService";

declare let AMap: any;
@Component({
  components: {
    [Calendar.name]: Calendar,
    [Field.name]: Field,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    "product-home": productHome,
  },
})
export default class Hotel extends Vue {
  // prop

  //data
  checkInDate = (this as any).$moment();
  checkOutDate = (this as any).$moment().add(1, "d");
  isCheckInDate = false;
  ischeckOutDate = false;
  dataShare = dataShare;
  // keyWords = "";
  frequenter = "";
  temporary = "";
  CityCode = "SHA";
  CityName = "上海市";
  name = "";
  entities = [];
  showKey = true;
  query: any = {
    ServiceType: "HotelService",
    DepartDate: this.checkInDate,
    ArriveDate: this.checkOutDate,
    ApplyArea: 1126,
    BookingType: "1529",
    pageIndex: 1,
    Latitude: this.Latitude,
    Longitude: this.Longitude,
    ComplateKeyword: true,
    ZoneID: 11181,
    ReturnDate: this.checkOutDate,
    ArriveCity: this.CityCode,
    ArriveCityName: this.CityName,
    FeatureCodes: "",
    Consumers: "",
    DistrictId: "",
    DistrictName: "",
    roomNumber: "",
    approvalCode: "",
  };

  //computed
  get temporarys() {
    return session.get("TemporaryInfos");
  }

  get City(): object {
    return dataShare.City;
  }

  get consumption() {
    let a = (this as any).formatDate(this.checkOutDate, "YYYY-MM-DD");
    let b = (this as any).formatDate(this.checkInDate, "YYYY-MM-DD");
    let day = (this as any).$moment(a).diff((this as any).$moment(b), "days");
    return day;
  }

  get keyWords() {
    return dataShare.keyword.Keyword;
  }
  set keyWords(value) {
    dataShare.keyword = value;
  }
  get Latitude() {
    return dataShare.keyword.Latitude;
  }
  get Longitude() {
    return dataShare.keyword.Longitude;
  }
  get ShowApproval() {
    return this.oldApprovalList?.some((item: any) => item.travelHotelsList);
  }
  created() {
    this.getCityData();
    this.searchapproval();
    dataShare.name = this.CityName;
  }
  //mounted
  mounted() {
    this.dataShare.keyword = {};
    if ((this as any).consumers && (this as any).consumers.length) {
      this.frequenter = (this as any).consumers[0].RoleName;
    }
    if ((this as any).temporarys && (this as any).temporarys.length) {
      this.temporary = (this as any).temporarys[0].ConsumerName;
    }
    this.dataShare.consumers = [];
  }

  //activated
  activated() {
    // this.Consumers = dataShare.consumers;
    if (this.City && (this as any).City.ZoneID) {
      const citys: {
        CityCode: "";
        CityID: "";
        CityName: "";
        CitySpell: "";
        CountryID: "";
        OrderBy: "";
        ZoneCode: "";
        ZoneID: "";
        ZoneName: "";
        ZoneType: "";
        keywords: "";
        label: "";
        value: "";
        originID: "";
        originName: "";
      } = this.City as any;
      citys.ZoneName = citys.label;
      citys.ZoneCode = citys.value;
      if (citys.ZoneType && citys.ZoneType != "1444") {
        citys.ZoneID = citys.CityID;
        dataShare.keyword.keyword = citys.ZoneName;
        citys.ZoneName = citys.CityName;
      } else {
        citys.ZoneID = citys.ZoneID;
      }
      if (dataShare.name === "") {
        this.CityCode = citys.ZoneCode;
        this.CityName = citys.ZoneName;
        this.query.ZoneID = citys.ZoneID as any;
      }
    }
  }
  setAddressData(value?: any) {
    console.log(value, "value--=-=-");
  }
  selectCheckInDate(time: string) {
    this.checkInDate = (this as any).$moment(time).format("YYYY-MM-DD");
    this.checkOutDate = (this as any)
      .$moment(time)
      .add(1, "d")
      .format("YYYY-MM-DD");
    this.isCheckInDate = false;
  }
  selectCheckOutDate(time: string) {
    this.checkOutDate = (this as any).$moment(time).format("YYYY-MM-DD");
    this.ischeckOutDate = false;
  }
  get minCheckInDate() {
    var minDate = (this as any).$moment(new Date());
    // if (minDate.hours() < 6) {
    //   minDate.add(-1, "days");
    // }
    return minDate.toDate();
  }
  get minCheckOutDate() {
    var minDate = (this as any).$moment(this.checkInDate).add(1, "days");
    return minDate.toDate();
  }
  // checkOutDate(day: any) {
  //   // const month = day.date.getMonth() + 1;
  //   // const date = day.date.getDate();
  //   // const toMonth = (this as any).$moment(this.checkInDate).month() + 1;
  //   const checkInDate = (this as any).$moment(this.checkInDate);
  //   if (checkInDate.isAfter(day.date)) {
  //     day.type = "disabled";
  //   }
  //   return day;
  // }
  selectCity() {
    dataShare.name = "";
    this.$router.push({
      path: "/selectCity",
      query: {
        ServiceType: this.query.ServiceType,
        ApplyArea: this.query.ApplyArea + "",
      },
    });
  }
  gotoKeyword() {
    // dataShare.name=''
    this.$router.push({
      path: "/mall/addKeywords",
      query: {
        ZoneID: this.query.ZoneID as any,
        CityName: this.CityName as any,
      },
    });
  }

  formatDate(value: Date, format: string = this.$root.$t("mall_hotel_hotel_yueri") as string) {
    return (this as any).$moment(value).format(format);
  }
  OneSelf = null;
  showConsumers() {
    let Flag = true;
    if (this.OneSelf == YesOrNo.Yes) {
      let consumers: any = [
        {
          RoleID: this.profile.UserID,
          RoleName: this.profile.UserName,
        },
      ];
      dataShare.consumers = consumers;
      return (Flag = false);
    }
    return Flag;
  }
  OneSelfs(value: any) {
    this.OneSelf = value;
  }
  @Watch("dataShare.consumers")
  handelConsumers(value: any) {
    this.Consumers = dataShare.consumers;
  }

  Consumers = [];
  //选择乘客
  gotoAddPassengers() {
    dataShare.consumers = this.Consumers;
    this.$router.push("addPassengers");
  }
  //取消选择旅客
  closeBar(consumer: object) {
    this.Consumers = _.difference(this.Consumers, [consumer]) as any;
  }

  call() {
    window.location.href = "tel://400-088-8020";
  }
  async search() {
    // 判断入住城市是否有一个在审批单中
    // if(this.isApproval && this.CityCodeList.length > 0 && !this.CityCodeList.includes(this.CityCode)){
    //   return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_shenpidanmudichengshi") as string);
    // }
    this.query.Consumers = JSON.stringify(this.Consumers.map((o: any) => ({ ConsumerID: o.RoleID, ConsumerName: o.RoleName })));
    var fmt = "YYYY-MM-DD";
    this.query.DepartDate = this.formatDate(this.checkInDate, fmt);
    this.query.ArriveDate = this.formatDate(this.checkOutDate, fmt);
    if (
      moment().hours() < 6 &&
      this.query.DepartDate == moment().format(fmt) &&
      this.query.ArriveDate ==
        moment()
          .add(1, "days")
          .format(fmt)
    ) {
      const isContinue = await Dialog.confirm({
        title: "入住提醒",
        message: `<span style='font-size:.4rem;line-height:.7rem'>您所需预定的酒店入住时间为本日下午二点，是否继续预定？如需预定即时入住的房型，请致电力程商旅<br/><a href="tel://4000888020" style="color:#1989fa">4000888020</a><br/>转<b style="color:#1989fa">人工预定！</b>谢谢</span>`,
        confirmButtonText: "继续预订",
        cancelButtonText: "拨打客服",
        cancelButtonColor: "#1989fa",
        overlay: true,
        closeOnClickOverlay: true,
      })
        .then(() => true)
        .catch(() => false);
      if (!isContinue) {
        this.call();
        return;
      }
    }

    this.query.ArriveCity = this.CityCode;
    this.query.ArriveCityName = this.CityName;
    if (this.approvalCode) this.query.approvalCode = this.approvalCode;
    let city = this.City as any;
    if (city && city.ZoneType == ZoneType.District) {
      this.query.DistrictId = city.originID;
      this.query.DistrictName = city.originName;
    }
    if (dataShare.bookingType) {
      this.query.BookingType = dataShare.bookingType;
    }
    if (this.Consumers.length == 0) {
      return this.$root.$toast.fail(this.$root.$t("mall_hotel_hotel_qingxuanzelvke") as string);
    }
    if (this.Consumers.length > 9) {
      return this.$root.$toast.fail(this.$root.$t("mall_hotel_hotel_lvkeshuliangshangxianqinglianxikefu") as string);
    }
    if (this.consumption > 20) {
      Dialog.confirm({
        title: this.$root.$t("mall_hotel_hotel_wenxintishi") as string,
        message: this.$root.$t("mall_hotel_hotel_zxydcgwfyknbzjylxkfh") as string,
        confirmButtonText: this.$root.$t("mall_hotel_hotel_jixuyuding") as string,
        cancelButtonText: this.$root.$t("mall_hotel_hotel_lianxikefu") as string,
        cancelButtonColor: "#1989fa",
        overlay: true,
        closeOnClickOverlay: true,
      })
        .then(() => {
          this.$router.push({ path: "hotel/list", query: this.query as any });
          return;
        })
        .catch(() => {
          window.location.href = "tel://400-088-8020";
        });
    } else {
      this.$router.push({ path: "hotel/list", query: this.query as any });
    }
    this.approvalCode = "";
    this.query.approvalCode = "";
  }
  getCityData() {
    const data = {
      ZoneType: "1444",
      ZoneTypes: "",
      ZoneName: "",
      CountryID: 151,
      Props: "CountryID,CityCode,CityName,CitySpell,OrderBy,ZoneID",
      PageSize: 10000,
    };
    baseService.getZoneList(data).then(res => {
      if (res.statusCode === 200) {
        this.entities = res.result.entities;
      } else {
        this.$notify({ type: "danger", message: "获取城市失败" });
      }
    });
  }
  // @Watch("dataShare.keyword", { deep: true })
  // handleWatch(newVal: any, oldVal: any) {
  //   this.keyWords = newVal.Keyword;
  //   this.query.Latitude = newVal.Latitude;
  //   this.query.Longitude = newVal.Longitude;
  // }
  /**获取地图定位*/
  geolocation: any = "";
  getLocation() {
    AMap.plugin("AMap.Geolocation", () => {
      this.geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        buttonOffset: new AMap.Pixel(10, 20),
        zoomToAccuracy: true,
        panToLocation: true,
        showButton: false,
        showMarker: false,
        showCircle: false,
        useNative: true,
      });
      this.geolocation.getCurrentPosition(<PositionCallback>(status: any, result: any) => {
        if (status === "complete") {
          this.showKey = false;
          this.$nextTick(() => {
            this.showKey = true;
          });
          if (result.addressComponent.city !== "") {
            this.CityName = result.addressComponent.city;
            dataShare.name = result.addressComponent.city;
          } else {
            this.CityName = result.addressComponent.province;
            dataShare.name = result.addressComponent.province;
          }
          let str = result.addressComponent.country + result.addressComponent.province + result.addressComponent.city + result.addressComponent.district + result.addressComponent.township;
          let last = str.slice(str.length - 1, str.length);
          let index = result.formattedAddress.lastIndexOf(last);
          this.dataShare.keyword.Keyword = result.formattedAddress.substring(index + 1, result.formattedAddress.length);
          let character = "中远两湾城中远两湾城四期";
          if (this.dataShare.keyword.Keyword.indexOf(character) != -1) {
            let newStr = "";
            let len = this.dataShare.keyword.Keyword.length;
            for (let i = 0; i < len; i++) {
              if (newStr.indexOf(this.dataShare.keyword.Keyword[i]) == -1) {
                newStr = newStr + this.dataShare.keyword.Keyword[i];
              }
            }
            this.dataShare.keyword.Keyword = newStr;
          }
          dataShare.keyword.Longitude = `${this.GeoToBMap(result.position.lng, result.position.lat)[0]}`;
          dataShare.keyword.Latitude = `${this.GeoToBMap(result.position.lng, result.position.lat)[1]}`;
          let a = this.CityName.indexOf("市");
          let city = this.CityName.substring(0, a);
          let ctyObj: any = this.entities.find((item: any) => item.CityName === city);
          if (JSON.stringify(ctyObj) !== "{}") {
            (this.query as any).ZoneID = ctyObj.ZoneID;
            this.CityCode = ctyObj.CityCode;
          } else {
            this.$notify({ type: "danger", message: "匹配城市id失败" });
          }
        } else {
          Dialog.confirm({
            message: "定位失败，请重新尝试，或选择城市查询。",
            confirmButtonText: "选择城市",
            confirmButtonColor: "#659bff",
            cancelButtonText: "知道了",
            cancelButtonColor: "#659bff",
          })
            .then(() => {
              this.selectCity();
            })
            .catch(() => {});
        }
      });
    });
  }
  //高德转百度
  GeoToBMap(gd_lng: any, gd_lat: any) {
    const X_PI = (Math.PI * 3000.0) / 180;
    const x = gd_lng;
    const y = gd_lat;
    const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
    const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
    const bd_lng = z * Math.cos(theta) + 0.0065;
    const bd_lat = z * Math.sin(theta) + 0.006;
    return [bd_lng, bd_lat];
  }
  // IP定位获取当前城市信息
  /*    getLngLatLocation() {
    AMap.plugin("AMap.CitySearch", function() {
      var citySearch = new AMap.CitySearch();
      citySearch.getLocalCity(function(status: any, result: any) {
        if (status === "complete" && result.info === "OK") {
          // 查询成功，result即为当前所在城市信息
          console.log(result,'-=-')
        }
      });
    });
  }*/
  approvalList: any = [];
  oldApprovalList: any = [];
  searchapproval() {
    let __self = this;
    huilianyiService.searchapprovals().then((res: any) => {
      __self.approvalList = res.result || [];
      __self.approvalList = __self.approvalList
        .map((item: any) => {
          const guestNames = item.participantList.map((item: any) => item.name).join(",");
          return { ...item, guestNames, isCheck: false };
        })
        .filter((i: any) => i.travelHotelsList);
      __self.oldApprovalList = JSON.parse(JSON.stringify(__self.approvalList));
      __self.approvalList = __self.oldApprovalList.filter((i: any) => i.approvalStatus == 2);
      __self.initBooking();
    });
  }
  initBooking() {
    let __self = this;
    const approvalCode = __self.$route.query.approvalCode;
    if (approvalCode) {
      const approvalInfo = __self.approvalList.find((item: any) => item.approvalCode === approvalCode);
      if (approvalInfo) {
        // 其余项禁用
        __self.approvalList.forEach((item: any) => {
          if (item.approvalCode === approvalCode) item.isCheck = true;
        });
        __self.oldApprovalList = JSON.parse(JSON.stringify(__self.approvalList));
        __self.echoSearchInfo(approvalInfo);
      }
    }
  }
  CityCodeList: any[] = [];
  approvalCode: string = "";
  echoSearchInfo(data: any) {
    let __self = this;
    const travelHotelsList = data.travelHotelsList;
    const hotelInfo = travelHotelsList[0];
    travelHotelsList.forEach((item: any) => {
      __self.CityCodeList.push(item.cityCode);
    });
    // 去重处理
    __self.CityCodeList = _.uniq(__self.CityCodeList);
    __self.approvalCode = data.approvalCode;
    __self.Consumers = data.participantList.map((item: any) => {
      return { RoleID: item.ConsumerID, RoleName: item.name };
    });

    if (hotelInfo.city != "" && hotelInfo.city != undefined) {
      __self.query.ArriveCity = hotelInfo.cityCode;
      __self.CityCode = hotelInfo.cityCode;
      __self.query.ArriveCityName = hotelInfo.city;
      __self.CityName = hotelInfo.city;
      __self.query.ZoneID = hotelInfo.cityID;
    }
    if (hotelInfo.fromDate || hotelInfo.fromDate != "") {
      __self.query.DepartDate = moment(hotelInfo.fromDate).format("YYYY-MM-DD");
      __self.checkInDate = moment(hotelInfo.fromDate).format("YYYY-MM-DD");
    }
    if (hotelInfo.leaveDate || hotelInfo.leaveDate != "") {
      __self.query.ArriveDate = moment(hotelInfo.leaveDate).format("YYYY-MM-DD");
      __self.checkOutDate = moment(hotelInfo.leaveDate).format("YYYY-MM-DD");
    }
    if (!__self.query.ArriveDate || __self.query.ArriveDate == "" || moment(__self.query.ArriveDate).diff(moment(__self.query.DepartDate)) < 0) {
      __self.query.ArriveDate = moment(__self.query.DepartDate)
        .add(1, "days")
        .format("YYYY-MM-DD");
      __self.checkOutDate = moment(__self.query.DepartDate)
        .add(1, "days")
        .format("YYYY-MM-DD");
    }
    __self.query.roomNumber = hotelInfo.roomNumber;
    // 直接执行查询
    __self.search();
  }
  activeStatus: number = 2;
  tabChange(status: number) {
    this.approvalList = this.oldApprovalList.filter((i: any) => i.status == status);
  }
  async goDetail(item: any) {
    // 检查item参数是否存在
    if (!item) {
      this.$root.$toast.fail("参数错误：订单信息不存在");
      return;
    }
    // 检查approvalCode是否存在
    if (!item.approvalCode) {
      this.$root.$toast.fail("参数错误：缺少审批编码");
      return;
    }
    // 根据订单类型选择对应的API
    let OrderID;
    if (!item.travelFlightsList.length) return;
    const res = await hotelService.getHotelOrderID(item.approvalCode);
    if (!res.isSucc) {
      this.$root.$toast.fail("获取订单ID失败！");
      return;
    }
    OrderID = res.result;
    // 跳转到订单详情页
    this.$router.push({
      path: "/order/detail",
      query: {
        OrderID,
      },
    });
  }
}
